import { app } from '../../../../../app';

app.component('companyIdpAuthenticatorsManageIntegration', {
    templateUrl: require('./idp-authenticator-integration.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/manage/integration/idp-authenticator-integration.component.js